import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { trakrefFontFamily } from '../../../../utils';
import { KeyboardArrowDown } from '@mui/icons-material';

const style = {
    '&.MuiChip-root': { borderRadius: 0, backgroundColor: '#fff', border: '1px solid #E3E8EB' },
    '& .MuiChip-label': { fontFamily: trakrefFontFamily, fontSize: '.75rem' },
    '& .MuiSvgIcon-root': { fontSize: '16px' }
};

const Filter = ({
    property,
    name,
    value,
    closeFilter,
    todayFilter,
    onClick,
    required
}) => (
    <Chip
        label={todayFilter ? name : <span>{name}{required && <span style={{ color: 'red', marginLeft: '4px' }}> *</span>}: {value}</span>}
        onDelete={() => closeFilter({ property, value })}
        deleteIcon={onClick ? <KeyboardArrowDown /> : <ClearIcon />}
        sx={style}
        onClick={(e) => {
            if (onClick) {
                onClick(e);
            }
        }}
    />
);

Filter.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    closeFilter: PropTypes.func.isRequired,
};

export default Filter;
